import { render, staticRenderFns } from "./PersonalDataForm.vue?vue&type=template&id=1d52171f&"
import script from "./PersonalDataForm.controller.js?vue&type=script&lang=js&"
export * from "./PersonalDataForm.controller.js?vue&type=script&lang=js&"
import style0 from "./PersonalDataForm.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports